export default __webpack_public_path__ + "static/media/Armbands of the Clay.98b209a5.jpg";